<div class="dining-availability-filter">
    <div class="main-form">
        <div class="date">
            <div class="label">{{labels.date}}</div>
            <finder-date-picker-wrapper
                [labels]="'calendarLabels'"
                [date]="selectedDate"
                [maxDays]="diningFilter.maxCalendarDays"
                [highlightedDates]="diningFilter.resortReservationDates"
                (dateChanged)="onDateChanged($event)">
                <finder-input
                    #datePicker
                    class="date-input"
                    type="text"
                    [value]="selectedDateString"
                    readonly="readonly">
                </finder-input>
            </finder-date-picker-wrapper>
        </div>
        @defer {
            <finder-ra-single-select
                class="time"
                [disabled]="false"
                [label]="labels.time"
                [value]="selectedTime"
                [options]="timesConfig.times"
                (itemSelected)="onTimeSelected($event)">
            </finder-ra-single-select>
        }
        <div class="party-size">
            <div class="label">{{labels.partySize}}</div>
            @defer {
                <finder-ra-counter
                    [lowerLimit]="1"
                    [upperLimit]="partySizeLimit"
                    [value]="selectedPartySize"
                    (updated)="onCounterChanged($event)">
                </finder-ra-counter>
            }
        </div>
        <finder-button
            class="submit"
            theme="primary"
            (click)="findRestaurantAvailability()"
            [disabled]="isLoading"
            [analyticsTracking]="false"
        >
            <div class="submit-label">
                <span [class.hidden]="isLoading">{{labels.search}}</span>
                <finder-loading-spinner *ngIf="isLoading" class="loading-spinner"></finder-loading-spinner>
            </div>
        </finder-button>
    </div>
    <div class="error-messages" *ngIf="error">
        <finder-font-icon name="alert" size="xs"></finder-font-icon>
        <span>{{ error }}</span>
    </div>
</div>
